import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import useStatsStore from "../../store/stats.store"; 
import "./notifications.scss";
import {List, Avatar, Badge, Alert } from 'antd';

function Notifications() {
    const { graphsGroupUserStats, newNotificationIndices, clearNotificationIndices } = useStatsStore();

    useEffect(() => {
      return () => {
        clearNotificationIndices(); 
      }
    }, []);

    const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
    const hasProfilePicture = Boolean(userDetails?.company_logo?.trim?.());

        const keyLabelMap = {
            qhuid: "QHUID",
            username: "Username",
            numjdscreated: "Number of JDs Created",
            numjdsupdated: "Number of JDs Updated",
            numjdsassigned: "Number of Assigned",
            numjdsworked: "Number of JDs Worked",
            numuploaded: "Number of Uploaded",
            numavailable: "Number of Available",
            numshared: "Number of Shared",
            numothers: "Number of Others",
            numtobeshared: "Number of To Be Shared",
            numfbpending: "Number of Feedback Pending",
            numfeedbackpending: "Number of Feedback Pending",
            numscreenrejected: "Number of Screen Rejected",
            numscreenrejectedhctc: "Number of Screen Rejected HCTC",
            numscreenrejectedhnp: "Number of Screen Rejected HNP",
            numscreenselected: "Number of Screen Selected",
            numscreenpartial: "Number of Screen Partial Suitable",
            numduplicates: "Number of Duplicates",
            numreviewpending: "Number of Review Pending",
            numnotsuitable: "Number of Not Suitable",
            numbelowaverage: "Number of Below Average",
            numaverage: "Number of Average",
            numaboveaverage: "Number of Above Average",
            numgoodmatch: "Number of Good Match",
            numpartialsuitable: "Number of Partial Suitable",
    // L0 Stage
            numl0sch: "Number of L0 Scheduled",
            numl0resch: "Number of L0 Rescheduled",
    numl0reject: "Number of L0 Rejected",
    numl0select: "Number of L0 Selected",
    numl0cancel: "Number of L0 Cancelled",
    numl0nopanel: "Number of L0 No Panel",
    numl0noshow: "Number of L0 No Show",
    numl0yresch: "Number of L0 Yet to Reschedule",
    numl0ysch: "Number of L0 Yet to Schedule",
    numL0CandidateDrop: "Number of L0 Candidate Drop",
    nunl0panelnotjoined: "Number of L0 Panel Not Joined",

    // L1 Stage
    numl1sch: "Number of L1 Scheduled",
    numl1resch: "Number of L1 Rescheduled",
    numl1reject: "Number of L1 Rejected",
    numl1select: "Number of L1 Selected",
    numl1cancel: "Number of L1 Cancelled",
    numl1nopanel: "Number of L1 No Panel",
    numl1noshow: "Number of L1 No Show",
    numl1yresch: "Number of L1 Yet to Reschedule",
    numl1ysch: "Number of L1 Yet to Schedule",
    numl1candidatedrop: "Number of L1 Candidate Drop",
    nunl1panelnotjoined: "Number of L1 Panel Not Joined",

    // L2 Stage
    numl2sch: "Number of L2 Scheduled",
    numl2resch: "Number of L2 Rescheduled",
    numl2reject: "Number of L2 Rejected",
    numl2select: "Number of L2 Selected",
    numl2cancel: "Number of L2 Cancelled",
    numl2nopanel: "Number of L2 No Panel",
    numl2noshow: "Number of L2 No Show",
    numl2yresch: "Number of L2 Yet to Reschedule",
    numl2ysch: "Number of L2 Yet to Schedule",
    numl2candidatedrop: "Number of L2 Candidate Drop",
    nunl2panelnotjoined: "Number of L2 Panel Not Joined",

    // HR Stage
    numhrsch: "Number of HR Scheduled",
    numhrresch: "Number of HR Rescheduled",
    numhrreject: "Number of HR Rejected",
    numhrcancel: "Number of HR Cancelled",
    numhrnopanel: "Number of HR No Panel",
    numhrnoshow: "Number of HR No Show",
    numhrcandidatedrop: "Number of HR Candidate Drop",
    nunhrpanelnotjoined: "Number of HR Panel Not Joined",
    numhryresch: "Number of HR Yet to Reschedule",
    numhrysch: "Number of HR Yet to Schedule",

    // Customer Stage
    numcustomersch: "Number of Customer Scheduled",
    numcustomerresch: "Number of Customer Rescheduled",

    // General
    numclientfbpending: "Number of Client Feedback Pending",
    numinterviewrejected: "Number of Interview Rejected",
    numhold: "Number on Hold",
    numfinalselect: "Number of Final Selected",
    numoffers: "Number of Offers",
    numnoshow: "Number of No Show",
  };

    const userStats = graphsGroupUserStats?.useractivity?.map((user) => {
        const keyWordsArray = {};
        Object.keys(user).forEach((key) => {
          if(user[key] !== 0 && key !== "qhuid") {
              keyWordsArray[keyLabelMap[key]] = user[key];
          }
        })     
        return keyWordsArray;
    });

    

    return (
      <>
        <div className='notifications-header'>
          <p>Updates from last 24hrs</p>
        </div>
        <div className="notifications-wrapper">
          {!hasProfilePicture && (
            <Alert
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
              message="Profile picture missing"
              description={
                <span>
                  You haven't uploaded a profile picture yet.{" "}
                  <Link to="/profile">Upload one now</Link> {/* change to your real profile route */}
                </span>
              }
            />
          )}
          <List
            itemLayout="vertical"
            dataSource={userStats}
            renderItem={(user, index) => (
              <List.Item>
                <List.Item.Meta
                  avatar={
                      <Badge dot={newNotificationIndices?.has(index)} color='green'>
                          <Avatar className="user-avatar">{user.Username[0] || '?'}</Avatar>
                      </Badge>
                  }
                  title={<span>{user.Username ? `${user.Username} made following changes` : 'User Notification'}</span>}
                  description={Object.entries(user).map(([key, value]) =>
                    key !== 'Username' ? (
                      <p key={key} style={{ color: 'black', marginBottom: '4px' }}>
                        {key}: {value}
                      </p>
                    ) : null
                  )}
                />
              </List.Item>
              )}
            />
        </div>
      </>
    );      
}

export default Notifications